import {
  GESTION_OPERATIVA_GET_AUTO_BEGIN,
  GESTION_OPERATIVA_GET_AUTO_SUCCESS,
  GESTION_OPERATIVA_GET_AUTO_FAILURE,
  GESTION_OPERATIVA_GET_AUTO_DISMISS_ERROR,
} from './constants'
import { BFFAgent } from '../../../common/BFFAgent'

export function getAuto(id, params) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: GESTION_OPERATIVA_GET_AUTO_BEGIN,
      data: {
        id,
      },
    })

    const promise = new Promise((resolve, reject) => {
      const doRequest = id
        ? BFFAgent.Catalogs.getAuto(id, params)
        : Promise.reject(new Error('Proporcionar id o source al cargar datos de item'))
      doRequest.then(
        (auto) => {
          dispatch({
            type: GESTION_OPERATIVA_GET_AUTO_SUCCESS,
            data: auto,
          })
          resolve(auto)
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: GESTION_OPERATIVA_GET_AUTO_FAILURE,
            data: { error: err },
          })
          reject(err)
        },
      )
    })

    return promise
  }
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetAutoError() {
  return {
    type: GESTION_OPERATIVA_GET_AUTO_DISMISS_ERROR,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_GET_AUTO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        catalog_id: action.data.id,
        autos: {
          ...state.autos,
          [action.data.id]: {
            getAutoPending: true,
            getAutoError: null,
          },
        },
      }

    case GESTION_OPERATIVA_GET_AUTO_SUCCESS:
      // The request is success
      return {
        ...state,
        autos: {
          ...state.autos,
          [action.data.id]: {
            ...action.data,
          },
        },
      }

    case GESTION_OPERATIVA_GET_AUTO_FAILURE:
      // The request is failed
      return {
        ...state,
        catalog_id: null,
        autos: {
          ...state.autos,
          [action.id]: {
            getAutoPending: false,
            getAutoError: action.data.error,
          },
        },
      }

    case GESTION_OPERATIVA_GET_AUTO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
      }

    default:
      return state
  }
}
